import * as Yup from "yup";

const expenseValidationSchema = Yup.object({

    carId: Yup.string()

        .required("خودرو را انتخاب کنید."),

    operDonDate: Yup.string()

        .required("تاریخ را وارد کنید."),

    cost: Yup.number()

        .transform((value, originalValue) =>

            originalValue === ""

                ? undefined

                : value

        )

        .typeError("مبلغ را وارد کنید.")

        .positive("مبلغ باید بزرگتر از صفر باشد.")

        .required("مبلغ را وارد کنید.")

        .max(2145000000, 'سقف مجاز 2,145,000,000 می باشد'),

    categoryId: Yup.number()

        .transform((value, originalValue) =>

            originalValue === ""

                ? undefined

                : value

        )

        .typeError("نوع هزینه را انتخاب کنید.")

        .required("نوع هزینه را انتخاب کنید."),

    operDonKM: Yup.number()

        .nullable()

        .transform((value, originalValue) =>

            originalValue === ""

                ? null

                : value

        )

        .min(0, "کیلومتر نامعتبر است.")

        .max(9999999, 'بیشتر از 7 رقم مجاز نیست'),

    description: Yup.string()

        .max(

            450,

            "حداکثر ۴۵۰ کاراکتر مجاز است."

        ),

});
export default expenseValidationSchema;